import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Info = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25 6.11978C14.5727 6.11978 6.11975 14.5727 6.11975 25C6.11975 35.4272 14.5727 43.8802 25 43.8802C35.4272 43.8802 43.8802 35.4272 43.8802 25C43.8802 14.5727 35.4272 6.11978 25 6.11978ZM2.2135 25C2.2135 12.4154 12.4153 2.21353 25 2.21353C37.5846 2.21353 47.7864 12.4154 47.7864 25C47.7864 37.5846 37.5846 47.7864 25 47.7864C12.4153 47.7864 2.2135 37.5846 2.2135 25ZM25 23.0469C26.0787 23.0469 26.9531 23.9213 26.9531 25V33.3333C26.9531 34.412 26.0787 35.2865 25 35.2865C23.9213 35.2865 23.0469 34.412 23.0469 33.3333V25C23.0469 23.9213 23.9213 23.0469 25 23.0469ZM25 14.7135C23.9213 14.7135 23.0469 15.588 23.0469 16.6667C23.0469 17.7453 23.9213 18.6198 25 18.6198H25.0208C26.0995 18.6198 26.974 17.7453 26.974 16.6667C26.974 15.588 26.0995 14.7135 25.0208 14.7135H25Z"
        fill={color}
      />
    </svg>
  )
}
